var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalaLottoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_300_5209)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.2559,
    cy: 17.0001,
    r: 16.2559,
    fill: "#D9FF00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.2559,
    cy: 17.0001,
    r: 16.2559,
    fill: "url(#paint0_radial_300_5209)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.2559,
    cy: 17.0001,
    r: 16.2559,
    fill: "url(#paint1_radial_300_5209)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2569 15.0361L17.6285 14.2293L18.9194 14.9958L16.2569 16.5691L9.80235 12.7367L16.2569 8.9043L22.7115 12.7367L21.4206 13.5032L16.2569 10.4373L12.4245 12.7367L16.2569 15.0361ZM13.1511 17.335L14.5227 18.1419V22.7004L10.6903 20.401V14.2691L9.39941 13.5026V21.1674L15.854 24.9998V17.335L13.1915 15.7617V17.335H13.1511ZM16.7017 17.3754V20.5623L17.9926 19.7958V18.1822L21.825 15.8828V20.4413L16.6614 23.5072V25.0402L23.1159 21.2078V13.5026L16.6614 17.335L16.7017 17.3754Z",
    fill: "#050226"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_300_5209",
    x: 0,
    y: -3.44684,
    width: 32.5117,
    height: 36.7029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.19098
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34949
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_300_5209"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_300_5209",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2559 14.1743) rotate(90) scale(19.0817)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_300_5209",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2559 0.744141) rotate(90) scale(40.7033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaLottoLogo);
export default __webpack_public_path__ + "static/media/gala-lotto-logo.9dfe2a8769e28e1212e37e4063cf455d.svg";
export { ForwardRef as ReactComponent };